// Statuts de confirmation (local_status). Les valeurs DOIVENT exister dans
// integration_service Order.LOCAL_STATUS, sinon le PATCH /status/ répond
// "Unsupported status value.".

// tone -> classes de badge (palette TEQA via le legacy bridge)
export const TONE_CLASSES = {
  success: "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400",
  info: "bg-sky-50 text-sky-700 dark:bg-sky-500/10 dark:text-sky-400",
  brand: "bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-400",
  warning: "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400",
  danger: "bg-rose-50 text-rose-700 dark:bg-rose-500/10 dark:text-rose-400",
  neutral: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
};

export const LOCAL_STATUSES = {
  new: { label: "Nouvelle", tone: "info" },
  pending_confirmation: { label: "À confirmer", tone: "info" },
  call_scheduled: { label: "Appel programmé", tone: "brand" },
  no_answer: { label: "Pas de réponse", tone: "warning" },
  busy: { label: "Ligne occupée", tone: "warning" },
  wrong_number: { label: "Numéro incorrect", tone: "danger" },
  call_back_later: { label: "À rappeler", tone: "brand" },
  confirmed: { label: "Confirmée", tone: "success" },
  rejected: { label: "Pas intéressé", tone: "danger" },
  duplicate: { label: "Doublon", tone: "neutral" },
  invalid_address: { label: "Adresse invalide", tone: "danger" },
  need_info: { label: "Infos manquantes", tone: "warning" },
  cancelled_by_client: { label: "Annulée (client)", tone: "danger" },
  cancelled_by_admin: { label: "Annulée (admin)", tone: "danger" },
  postponed: { label: "Reportée", tone: "neutral" },
  rescheduled: { label: "Reprogrammée", tone: "brand" },
  completed: { label: "Terminée", tone: "success" },
  refunded: { label: "Remboursée", tone: "neutral" },
};

// Actions rapides de la ligne "workflow"
export const PRIMARY_STATUSES = [
  { value: "confirmed", label: "Confirmer", tone: "success" },
  { value: "no_answer", label: "Pas de réponse", tone: "warning" },
  { value: "call_back_later", label: "Rappeler", tone: "brand" },
];

export const OTHER_STATUSES = [
  { value: "busy", label: "Ligne occupée / boîte vocale", tone: "warning" },
  { value: "rejected", label: "Pas intéressé", tone: "danger" },
  { value: "wrong_number", label: "Numéro incorrect", tone: "danger" },
  { value: "invalid_address", label: "Adresse invalide", tone: "danger" },
  { value: "need_info", label: "En attente décision / infos", tone: "warning" },
  { value: "postponed", label: "Reporter", tone: "neutral" },
  { value: "rescheduled", label: "Reprogrammer", tone: "brand" },
  { value: "duplicate", label: "Commande doublée", tone: "neutral" },
  { value: "cancelled_by_client", label: "Annuler (client)", tone: "danger" },
];

export const ALL_STATUSES = [...PRIMARY_STATUSES, ...OTHER_STATUSES];

export const STATUS_MAP = ALL_STATUSES.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});

export function localStatusMeta(value) {
  return LOCAL_STATUSES[value] || { label: value || "—", tone: "neutral" };
}

// Onglets de la page "Commandes en attente"
export const PENDING_TABS = [
  { key: "all", label: "Toutes", statuses: null },
  { key: "new", label: "Nouvelles", statuses: ["new", "pending_confirmation"] },
  { key: "no_answer", label: "Pas de réponse", statuses: ["no_answer", "busy"] },
  {
    key: "callback",
    label: "À rappeler",
    statuses: ["call_back_later", "call_scheduled", "postponed", "rescheduled"],
  },
  { key: "issues", label: "À corriger", statuses: ["wrong_number", "invalid_address", "need_info"] },
  { key: "rejected", label: "Refusées", statuses: ["rejected"] },
];
